import { MapPin, Users, Clock, Phone, Coins } from "lucide-react";
import { Input } from "@/components/ui/input";
import { formatDate, formatDuration } from "@/lib/incident";

const MetaField = ({ icon: Icon, label, value, extra, mono }) => (
  <div className="border border-border bg-[#0A0A0A] p-4">
    <div className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground flex items-center gap-2 mb-2">
      <Icon className="w-3.5 h-3.5" /> {label}
    </div>
    <div className={`text-sm ${mono ? "font-mono" : ""}`}>{value}</div>
    {extra && <div className="text-xs text-muted-foreground mt-1 font-mono">{extra}</div>}
  </div>
);

const EditableMeta = ({ icon: Icon, label, value, onChange, testid }) => (
  <div className="border border-border bg-[#0A0A0A] p-4">
    <div className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground flex items-center gap-2 mb-2">
      <Icon className="w-3.5 h-3.5" /> {label}
    </div>
    <Input value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="bg-transparent border-0 px-0 h-auto rounded-none focus-visible:ring-0 border-b border-transparent hover:border-border focus-visible:border-[#007AFF] text-sm" />
  </div>
);

export const IncidentMetaGrid = ({ draft, onSet }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <MetaField icon={Clock} label="Date / Time" value={formatDate(draft.occurred_at)}
      extra={`Duration ${formatDuration(draft.duration_seconds)}`} />
    <MetaField icon={Phone} label="Caller" value={draft.caller_number || "Unknown"} mono />
    <EditableMeta icon={MapPin} label="Location" value={draft.location}
      onChange={(v) => onSet("location", v)} testid="location-input" />
    <EditableMeta icon={Users} label="People Involved" value={draft.people_involved}
      onChange={(v) => onSet("people_involved", v)} testid="people-input" />
    {draft.call_cost != null && (
      <MetaField icon={Coins} label="Call Cost" mono
        value={<span data-testid="call-cost">{`$${Number(draft.call_cost).toFixed(2)}`}</span>}
        extra={`${draft.billed_minutes || 1} min billed on the paid line`} />
    )}
  </div>
);
